import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { inscription } from '../services/api';
import API from '../services/api';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=900&q=80';

const Inscription = () => {
  const [form, setForm] = useState({
    nom: '', prenom: '', email: '',
    telephone: '', mot_de_passe: '', role: 'acheteur'
  });
  const [accepteCgu, setAccepteCgu] = useState(false);
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(FALLBACK_IMAGE);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/hero/image/register_image')
      .then(res => { if (res.data?.url) setImageUrl(res.data.url); })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accepteCgu) {
      setErreur("Vous devez accepter les conditions d'utilisation pour créer un compte.");
      return;
    }
    setLoading(true);
    setErreur('');
    try {
      const res = await inscription(form);
      login(res.data.token, res.data.user);
      navigate('/profil');
    } catch (err) {
      setErreur(err.response?.data?.message || 'Erreur lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ background: '#0A0A0A' }}>

      {/* Gauche — image */}
      <div className="hidden md:flex md:w-1/2 relative overflow-hidden">
        <img
          src={imageUrl}
          alt="voiture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{
          background: 'linear-gradient(to right, rgba(0,0,0,0.3), rgba(10,10,10,0.8))'
        }} />
        <div className="absolute inset-0 flex flex-col justify-center px-12">
          <h2 className="text-white text-3xl font-black mb-4">
            Rejoignez <span style={{ color: '#F5A623' }}>JJ Cars</span>
          </h2>
          <p className="text-gray-300 text-lg">
            Créez votre compte et commencez à acheter ou vendre des véhicules dès aujourd'hui.
          </p>
        </div>
      </div>

      {/* Droite — formulaire */}
      <div className="w-full md:w-1/2 flex items-center justify-center px-8 py-8">
        <div className="w-full max-w-md">

          {/* Logo centré */}
          <div className="text-center mb-5">
            <Link to="/" className="inline-block">
              <img src="/logo.jpg" alt="JJ Cars" className="h-12 w-auto object-contain mx-auto" />
            </Link>
          </div>

          <h1 className="text-white text-2xl font-black mb-1">Créer un compte</h1>
          <p className="text-gray-500 mb-5 text-sm">Rejoignez la marketplace automobile premium</p>

          {erreur && (
            <div className="bg-red-900 bg-opacity-30 border border-red-500 text-red-400 p-2.5 rounded-xl mb-3 text-xs">
              {erreur}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold text-gray-400 mb-1">Nom</label>
                <input
                  type="text"
                  required
                  value={form.nom}
                  onChange={(e) => setForm({ ...form, nom: e.target.value })}
                  style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                  className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                  placeholder="Dupont"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-400 mb-1">Prénom</label>
                <input
                  type="text"
                  required
                  value={form.prenom}
                  onChange={(e) => setForm({ ...form, prenom: e.target.value })}
                  style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                  className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                  placeholder="Jean"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">Email</label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="votre@email.com"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">Téléphone</label>
              <input
                type="tel"
                value={form.telephone}
                onChange={(e) => setForm({ ...form, telephone: e.target.value })}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="24100000000"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">Mot de passe</label>
              <input
                type="password"
                required
                value={form.mot_de_passe}
                onChange={(e) => setForm({ ...form, mot_de_passe: e.target.value })}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="••••••••"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">Je suis</label>
              <select
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
              >
                <option value="acheteur">Acheteur</option>
                <option value="vendeur_particulier">Vendeur particulier</option>
              </select>
            </div>

            {/* Acceptation CGU */}
            <div
              style={{ background: '#1a1a1a', border: '1px solid #333' }}
              className="rounded-xl p-3"
            >
              <label className="flex items-start gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={accepteCgu}
                  onChange={(e) => setAccepteCgu(e.target.checked)}
                  style={{ accentColor: '#F5A623' }}
                  className="mt-0.5 w-4 h-4 flex-shrink-0 cursor-pointer"
                />
                <span className="text-gray-400 text-xs leading-relaxed">
                  J'accepte les{' '}
                  <Link
                    to="/cgu"
                    target="_blank"
                    style={{ color: '#F5A623' }}
                    className="font-bold hover:underline"
                  >
                    conditions d'utilisation
                  </Link>
                  . Je reconnais que JJ Cars est une plateforme de mise en relation
                  et que les accords se font directement entre
                  acheteur et vendeur.
                </span>
              </label>
            </div>

            <button
              type="submit"
              disabled={loading || !accepteCgu}
              style={{ background: accepteCgu ? '#F5A623' : '#5a4513' }}
              className="w-full text-black py-2 rounded-xl font-black text-sm hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Inscription...' : 'Créer mon compte'}
            </button>
          </form>

          <p className="text-center text-gray-500 mt-5 text-sm">
            Déjà un compte ?{' '}
            <Link to="/connexion" style={{ color: '#F5A623' }} className="font-bold hover:opacity-80">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Inscription;